define(["../templateFactoryModule", "angular"], function (templateFactoryModule, angular) {
    "use strict";

    return templateFactoryModule.service("templateFactoryHorizontalStackedBarTemplate", [function () {
        return function (config) {
            var element = angular.element("<div>");
            if (config.context) {
                element.attr("horizontal-stacked-bar-chart", config.context);
            }
            if (config.width) {
                element.attr("size", config.width);
            }
            if (config.height) {
                element.attr("size", config.height);
            }
            if (config.absolute) {
                element.attr("absolute", config.absolute);
            }
            return element;
        };
    }]);
});
